import angular from 'angular';
import { IFolhaPonto } from '../../../models/folhaponto.model';

export class FolhasPontoVisualizarpdfModalService {
    static $inject = ['$uibModal'];

    constructor(public $uibModal: ng.ui.bootstrap.IModalService) {}

    open(entity: IFolhaPonto) {
        return this.$uibModal.open({
            template: require('html-loader!./visualizarpdf.modal.html'),
            controller: 'FolhasPontoVisualizarpdfModalController',
            controllerAs: '$ctrl',
            windowClass: 'nsj-modal-lg-no-height',
			backdrop: 'static',
            resolve: {
                entity: () => angular.copy(entity)
            }
        });
    }
}
